<template>
  <v-layout :class="{'bold-text': open}" row>
    <v-flex xs2 sm1 class="align-self-center" :class="{'pl-3': $vuetify.breakpoint.smAndUp}">
      <v-icon :style="iconStyle" medium>mdi-account-multiple</v-icon>
    </v-flex>
    <v-flex     sm2 v-if="$vuetify.breakpoint.smAndUp">
      {{$t('intervention')}}
    </v-flex>
    <v-flex     sm2 v-if="$vuetify.breakpoint.smAndUp">
      {{intervention.intervention.creationDate | date}}
    </v-flex>
    <v-flex xs5 sm3 class="prevent-overflow">
      {{$t(intervention.intervention.category.description)}}
    </v-flex>
    <v-flex xs5 sm2 v-if="intervention.intervention.status === 'CLOSED'" class="status-complete" ref="status">
      <v-icon>mdi-check-all</v-icon>
      {{$t('intervention_status_'+ intervention.intervention.status)}}
    </v-flex>
    <v-flex xs5 sm2 v-if="intervention.intervention.status === 'DELAYED'" class="status-delayed" ref="status">
      <v-icon>mdi-clock-alert</v-icon>
      {{$t('intervention_status_'+ intervention.intervention.status)}}
    </v-flex>
    <v-flex xs5 sm2 v-if="intervention.intervention.status === 'IN_PROGRESS'" class="status-in-progress" ref="status">
      <v-icon>mdi-update</v-icon>
      {{$t('intervention_status_'+ intervention.intervention.status)}}
    </v-flex>
    <v-flex xs5 sm2 v-if="intervention.intervention.status === 'NEW'" ref="status">
      <v-icon>mdi-alert-decagram</v-icon>
      {{$t('intervention_status_'+ intervention.intervention.status)}}
    </v-flex>
  </v-layout>
</template>

<script>
  import DateFormat from '../../../mixins/DateFormat'
  import Colors from '../../../mixins/Colors'

  export default {
    name: 'student-profile-intervention-header',
    props: ['intervention', 'open'],
    mixins: [DateFormat, Colors],
    data () {
      return {
        timeUp: false,
        iconStyle: ''
      }
    },
    mounted () {
      this.$el.parentElement.parentElement.style.transition = 'all 0.3s ease-in'
      this.changeColors()
      setTimeout(() => {
        this.timeUp = true
      }, 1000)
    },
    watch: {
      open (value) {
        this.changeColors()
        if (!this.timeUp) {
          setTimeout(() => {
            this.$el.scrollIntoView({behavior: 'smooth', block: 'center'})
          }, 400)
        }
      },
      backgroundColor (value) {
        console.log(value)
      }
    },
    computed: {},
    methods: {
      changeColors () {
        const bgColor = this.lightenColor(this.$vuetify.theme.primary, 2)
        const textColor = this.getTextColor(bgColor)
        this.$el.parentElement.parentElement.style.backgroundColor = this.open ? bgColor : ''
        this.$el.parentElement.parentElement.style.color = this.open ? textColor : ''
        this.$refs.status.style.color = this.open ? textColor : ''
        this.iconStyle = this.open ? {color: textColor} : ''
      }
    }
  }
</script>

<style scoped>
  .bold-text {
    font-weight: 900;
  }

  .align-self-center {
    align-self: center;
  }
  .status-complete {
    color: #7DD181
  }
  .status-delayed {
    color: #EE6352
  }
  .status-in-progress {
    color: #3FA7D6
  }
  .status-new {
    color: #7DD181
  }
</style>



// WEBPACK FOOTER //
// src/components/intervention/studentProfileIntervention/StudentProfileInterventionHeader.vue